import { createNanoEvents } from 'nanoevents';

export const pasteSpecialEventBus = createNanoEvents();
